const moduleSelectedTypeConsultation = {
    namespaced: true,
    state: {
        selectedTypeConsultation: {},
        timesSelected: {
            hourStart: '',
            hourEnd: '',
        }
    },
    getters: {
        getSelectedTypeConsultation(state) {
            return state.selectedTypeConsultation;
        },
        getTimesSelected(state) {
            return state.timesSelected;
        },
    },
    mutations: {
        setSelectedTypeConsultation(state, selectedTypeConsultation) {
            state.selectedTypeConsultation = selectedTypeConsultation;
        },
        setTimesSelected(state, { hourStart, hourEnd }) {
            state.timesSelected.hourStart = hourStart
            state.timesSelected.hourEnd = hourEnd
        },
        setRestoreState(state){
            state.selectedTypeConsultation={}
            state.timesSelected.hourStart=''
            state.timesSelected.hourEnd=''
        }
    },
}

export default moduleSelectedTypeConsultation;